import {
  ORDER_FEEDBACK,
  REVIEW_ERROR_CODE,
  REVIEW_FAILURE_REASON,
} from '../constants/constants';
import {reduceImageSize} from './image.helper';

/**
 * The product-review service's refusal, from a GraphQL errors array (in a 200
 * response or a failed request's body). `message` is shown under the product;
 * a network failure has none, so the modal falls back to its own copy.
 */
export const getReviewError = errors => {
  const error = errors && errors[0];
  return {
    message: (error && error.message) || null,
    code: (error && error.extensions && error.extensions.code) || null,
  };
};

// Already reviewed for this order, or within the last 6 weeks: either way the
// item can't be reviewed now, so the modal locks it.
export const isLockingReviewCode = code =>
  code === REVIEW_ERROR_CODE.ALREADY_REVIEWED ||
  code === REVIEW_ERROR_CODE.RECENTLY_REVIEWED;

export const getReviewFailureReason = code =>
  code === REVIEW_ERROR_CODE.ALREADY_REVIEWED
    ? REVIEW_FAILURE_REASON.ALREADY_REVIEWED
    : code === REVIEW_ERROR_CODE.RECENTLY_REVIEWED
    ? REVIEW_FAILURE_REASON.RECENTLY_REVIEWED
    : REVIEW_FAILURE_REASON.ERROR;

/**
 * The popup's items, in the server's order, with names and images from
 * product search. A product search doesn't return keeps the server's name and
 * has no image: the server only lists products that can be reviewed.
 */
export const getPromptItems = (promptItems, products) =>
  (promptItems || [])
    .filter(item => item && item.itemId)
    .map(item => {
      const product =
        (products || []).find(found => found.itemId === item.itemId) || {};
      const image = product.imageLinks && product.imageLinks[0];
      return {
        itemId: item.itemId,
        itemName: product.itemName || item.itemName,
        image: image
          ? reduceImageSize(image, false, ORDER_FEEDBACK.IMAGE_SIZE)
          : null,
      };
    });

// Items on screen the customer could still rate but didn't in this submit.
export const getUnratedItemIds = (items, reviews, lockedItemIds) =>
  (items || [])
    .map(item => item.itemId)
    .filter(
      itemId =>
        (lockedItemIds || []).indexOf(itemId) < 0 &&
        !(reviews || []).some(review => review.itemId === itemId)
    );
